export enum TwitterSubTypeEnum {
    RETWEET = 'RETWEET',
    TWEET = 'TWEET',
    QUOTE = 'QUOTE',
    REPLY = 'REPLY',
}
